import { MarkConversationAction } from '@kamernet/core/ApiClient/Kamernet';

import { AnalyticsEvent } from '../types';

const ACTION_TO_EVENT_NAME: Record<MarkConversationAction, AnalyticsEvent> = {
  [MarkConversationAction.Read]: AnalyticsEvent.MyConversationsMarkRead,
  [MarkConversationAction.Unread]: AnalyticsEvent.MyConversationsMarkUnread,
  [MarkConversationAction.Favorite]: AnalyticsEvent.MyConversationsMarkFavorite,
  [MarkConversationAction.Unfavorite]:
    AnalyticsEvent.MyConversationsMarkUnfavorite,
  [MarkConversationAction.Trash]: AnalyticsEvent.MyConversationsMarkTrash,
  [MarkConversationAction.Restore]: AnalyticsEvent.MyConversationsMarkRestore,
  [MarkConversationAction.Delete]: AnalyticsEvent.MyConversationsMarkDelete,
};

export function getMarkConversationEventName(
  action: MarkConversationAction,
): AnalyticsEvent {
  return ACTION_TO_EVENT_NAME[action];
}
